// src/services/sliderApi.js
import axios from 'axios';
// import {id} from "element-plus/es/locale";

const apiClient = axios.create({
    // baseURL: 'http://192.168.2.104:8090', // Spring Boot后端地址
    baseURL: 'https://www.gratefulcore.com.cn/api/', // Spring Boot后端地址
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
});
export default {
    // 获取所有轮播图
    getSliderImages() {
        return apiClient.get('/');
    },

    // 首页接口
    // 轮播图
    getList() {
        return apiClient.get('/get/carouselImg/get/list');
    },
    // 解决方案
    solutionGetList() {
        return apiClient.get('/get/solution/get/list/show');
    },
    // 产品中心
    ProductsGetList() {
        return apiClient.get('/get/productClass/getList/show');
    },
    // 案例展示
    CasesGetList() {
        return apiClient.get('/get/case/get/class/list/show');
    },
    // 新闻中心
    CentreStList() {
        return apiClient.get('/get/news/getListNew');
    },
    // 解决方案接口
    Solutions() {
        return apiClient.get('/get/solution/get/listTwo');
    },
    Solutions1() {
        return apiClient.get('/get/solution/get/listTwo');
    },
    getBusinessList() {
        return apiClient.get('/get/business/list');
    },
    setRequestMessage(data) {
        return apiClient.post('/get/requestMessage/add', data);
    },
    sendAdminTuiShong(data){
        return apiClient.post('/get/sendDing/sendAdminTuiShong', data);
    },
    getProductClassNameList(){
        return apiClient.get('/get/productClass/getList');
    },
    getProductByClassId(productClassId){
        return apiClient.get('/get/product/get/showList/'+productClassId);
    },
    getProductById(productId){
        return apiClient.get('/get/product/get/'+productId);
    },
    addMinio(file){
        return apiClient.post('/get/img/addMinio',file,{
            headers: {
                'Content-Type': 'multipart/form-data' // 必须设置这个请求头
            }
        });
    },
    AddTechnical(data){
        return apiClient.post('/get/technical/add',data);
    },
    sendAdminTechnicalSupport(data){
        return apiClient.post('/get/sendDing/sendAdminTechnicalSupport', data);
    },
    getCase(){
        return apiClient.get('/get/case/get/class');
    },
    getCaseListByClassId(classId){
        return apiClient.get('/get/case/get/list/'+classId);
    },
    getCaseListA(){
        return apiClient.get('/get/case/get/listA');
    },
    getCaseById(id){
        return apiClient.get('/get/case/get/'+id);
    },
    getListAll(){
        return apiClient.get('/get/case/get/listA');
    },
    CaseShow(id){
        return apiClient.get( '/get/solution/get/'+id);
        // 解决方案详情,解决方案详情
    },
};
